import Vue from 'vue'
import App from './App.vue'
import router, {hasRoute, addDynamicRoutes} from './router'
import store from './store'
import i18n from '@/locale/index'
// import CreateAPI from 'vue-create-api'
// Vue.use(CreateAPI)

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import {
  chat,
  chatLogin,
  $TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
  eventInstance,
  initIMInstance,
	kickOutIMReLogin,
} from "@/common/js/chat/init";


Vue.prototype.$eventInstance = eventInstance;
Vue.prototype.$TUIKIT = chat;
Vue.prototype.$TencentCloudChat = $TencentCloudChat;
Vue.prototype.$TencentCloudChatEvent = $TencentCloudChatEvent;
Vue.prototype.$TencentCloudChatType = $TencentCloudChatType;
Vue.prototype.$SKD_STATUS = $SKD_STATUS;

initIMInstance();//初始化IM实例
// kickOutIMReLogin();//被踢出后重新登录
let userId = store.state.id;
if(userId){
  console.log("刷新后重新登录");
  if(!$SKD_STATUS){
    chatLogin({userID: userId});
  }
}

let isFirstLogin = JSON.parse(localStorage.getItem("isFirstLogin"));
if(!isFirstLogin){
  isFirstLogin = {
    "login": true,
    "taskdetail": true,
    "publishwork": true,
    "mytask": true
  }
  localStorage.setItem("isFirstLogin",JSON.stringify(isFirstLogin));
}

/* 不可用  需要更换新的API
import GAuth from "vue-google-oauth2";
import {
  gAuthOption
} from "@/common/js/login";
Vue.use(GAuth, gAuthOption);
*/

/*
import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton);
*/

import ActivityDialog from "./components/activitydialog/activitydialog.vue"
Vue.component("ActivityDialog",ActivityDialog);

Vue.config.productionTip = false;

import "@/common/stylus/index.styl";

// 在main.js中添加
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister())
  })
}

// 引入页面适配
import "@/common/js/rem";

import "./common/el-component";


const initTabPanel = (route)=>{
  const {meta,name} = route;
  let tab = {
    title: meta.title,
    name
  };
  store.dispatch("addEditableTabs",tab);
  store.dispatch("getEditabletabsValue",name);
}

const whiteLists = ["login","retrievepassword","showtaskdetail","videos","register","index","middle","download","privacypolicy","serviceprotocol","transferprotocol"]

router.beforeEach((to, from, next)=>{

  let token = store.state.token;
  // token = "adfadfjaldjfal";
  // console.log("whiteLists.includes(to.name)==",whiteLists.includes(to.name),"token",!token,"to.name===",to.name);
  // if(!token){
  if((!whiteLists.includes(to.name)) && (!token)){
    // console.log("=======11111111======",(!whiteLists.includes(to.name)) && (!token));
    next({
      // name: "login"
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
  }
  else{
    // console.log("==============222222222========");
    next();
  }
  // }
  // else{
  //   if(to.name === "login" || to.name === "register"){
  //     next({
  //       name: "home"
  //     });
  //   }
  //   else{
  //
  //     // if(to.meta && to.meta.title){
  //     //   initTabPanel(to);
  //     // }
  //
  //     if(store.getters.dynamicRoutes && hasRoute(router,to)){
  //       next();
  //     }
  //     else{
  //       addDynamicRoutes(router,"layout",store.getters.dynamicRoutes);
  //       next({ ...to, replace: true });
  //     }
  //   }
  // }

 // next();
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
